import {DeviceType} from '../components/Controler';
import {AccountInfo} from '@azure/msal-browser';
import {UUID} from 'crypto';
import {AudioLevelAPI} from '../components/AudioLevel';
import MediaDeviceInfoWithState from "../utils/MediaDeviceInfoPlus";

const getServerUrl = (): string => {
    const hostname = window.location.hostname;
    if (hostname === 'localhost') return 'https://dev-enersound.azurewebsites.net/';
    // if (hostname === 'localhost') return 'http://localhost:8080/';
    if (hostname === 'devcdnstorageenersound.z13.web.core.windows.net') return 'https://dev-enersound.azurewebsites.net/';
    return 'https://enersound.azurewebsites.net/';
};

const getBroadcastServerUrl = (): string => {
    const hostname = window.location.hostname;
    if (hostname === 'localhost') return 'https://dev-enersound-broadcast.azurewebsites.net/';
    if (hostname === 'devcdnstorageenersound.z13.web.core.windows.net') return 'https://dev-enersound-broadcast.azurewebsites.net/';
    return 'https://enersound-broadcast.azurewebsites.net/';
};

const getBroadcastUrl = (): string => {
    const hostname = window.location.hostname;
    if (hostname === 'localhost') return 'http://localhost:3000/';
    if (hostname === 'devcdnstorageenersound.z13.web.core.windows.net') return 'https://devcdnstorageenersound.z13.web.core.windows.net/';
    return 'https://cloud.enersound.com/';
};

export const SERVER_URL: string = getServerUrl();
export const BROADCAST_SERVER_URL: string = getBroadcastServerUrl();

export const BROADCAST_URL: string = getBroadcastUrl();

export const SESSION_URL: string = 'session';
export const SESSION_SPEECH_TOKEN_URL: string = 'session/speech-token-management';
export const SESSION_HEARTBEAT_URL: string = 'session/heartbeat';
export const sessionTranslateUrl = (sessionId: string): string => `session/${sessionId}/translate`;
export const USER_URL: string = 'user';
export const BILLING_URL_PATH: string = 'billing';
export const BACK_OFFICE_URL_PATH: string = 'backOffice';
export const GLOSSARY_URL_PATH: string = 'glossary';
export const BROADCAST_SHARECODE_URL_PATH: string = 'broadcast/sharecode';


export const isDevEnvironment = (): boolean => {
    const hostname = window.location.hostname;
    return hostname === 'localhost'
        || hostname === 'devcdnstorageenersound.z13.web.core.windows.net'
        || hostname === 'preprodcdn.z13.web.core.windows.net';
};

export const AUTHORIZE_CLIENT_KEY = isDevEnvironment()
    ? "6Z2876C6yKqs299N7dN6cCRxGP8Dxw8eE5PZYW5wg6e988nGr6UKwGWh99tSdLwp"
    : "5m4q3cF2bt4S3hUJcfxb5EAL5FBJTy4uE88q4hVpGmCReL4MF35aNbQxD3k3Gexu";
export const AUTHORIZE_LOGIN_ID = isDevEnvironment()
    ? "6Q6k4sCV"
    : "5CUg73p5";
export const AUTHORIZE_SCRIPT_URL = isDevEnvironment()
    ? 'https://jstest.authorize.net/v3/AcceptUI.js'
    : 'https://js.authorize.net/v3/AcceptUI.js';

export const TOS_URL = isDevEnvironment()
    ? 'https://devcdnstorageenersound.z13.web.core.windows.net/documents/agreement.html'
    : 'https://cloud.enersound.com/documents/agreement.html';

//export const HELP_URL = 'https://devcdnstorageenersound.z13.web.core.windows.net/documents/help.html';
export const HELP_URL = 'https://enersound.com/cloud/help/';

export const DEFAULT_VOICE_INDEX = 0;

export const BIDIRECTIONAL_PANEL_COLORS = [
    '#1464f6',
    '#e84393',
    '#f5a623',
    '#27ae60',
    '#9b59b6',
    '#e74c3c',
    '#00b8d4',
    '#ff6f00',
];

export type BiDirectionalLanguage = {
    name: string;
    recognitionKey: string;
    translationKey: string;
    speakKey: string;
    voices: TtsVoice[];
}

export const OUTPUT_ONLY_DEVICE_ID = 'output-only';
export const INPUT_ONLY_DEVICE_ID = 'input-only';

export type BidirectionalPanel = {
    id: string;
    language: BiDirectionalLanguage | null;
    inputDevice: MediaDeviceInfo | null;
    outputDevice: MediaDeviceInfo | null;
    inputGain: number;
    outputGain: number;
    voiceName: string | null;
    textOnly: boolean;
    outputOnly: boolean;
    inputOnly: boolean;
    color: string;
}

export const PACE_VALUES = [
    {
        value: 0.6,
        label: 'x0.5'
    },
    {
        value: 0.85,
        label: 'x0.75'
    },
    {
        value: 1.20,
        label: 'x1.0'
    },
    {
        value: 1.35,
        label: 'x1.25'
    },
    {
        value: 1.5,
        label: 'x1.5'
    }
    // {
    //     value: 1.75,
    //     label: 'x1.75',
    // },
    // {
    //     value: 2.0,
    //     label: 'x2.0',
    // }
];

export type Language = {
    id: string;
    name: string;
    nativeName: string | undefined;
}

export type RawSpeakRecognitionL = {
    [key: string]: string
}

export type TtsVoice = {
    name: string,
    gender: 'F' | 'M',
}

export type RawText2SpeechL = {
    [key: string]: {
        name: string,
        voices: TtsVoice[]
    }
}

export type RawTranslationL = {
    translation: {
        [key: string]: {
            name: string,
            nativeName: string,
            dir: string
        }
    }
}

export type RecognizableAndTranslatableLanguage = {
    // translationKey?: string, //"am"
    name: string, //Amharic
    // nativeName?: string, //አማርኛ
    recognitionKey: string //"am-ET"
}

export type TranslatableAndSpeakableLanguage = {
    speakKey: string, //"am-ET"
    name: string,
    voices: TtsVoice[],
    translationKey: string, //"am"
}

export type DeviceConfig = {
    panelId: string,
    type: DeviceType,
    language?: RecognizableAndTranslatableLanguage | TranslatableAndSpeakableLanguage | null,
    gain?: number,
    pace?: number,
    device?: MediaDeviceInfo | null,
    textOnly?: boolean,
    autoDetectLang?: boolean,
    audioLevelAPIRef?: AudioLevelAPI | null,
    voiceName?: string,
}

export type Output = {
    id: string
    device: MediaDeviceInfo
    language: TranslatableAndSpeakableLanguage
    gain: number
    configComplete: boolean
    isExtra: boolean
    pace: number
    // getLevel(): number;
    textOnly: boolean
    voiceIndex: number
}

/**
 * Removes outputs that target the same language (`language.translationKey`), keeping the first
 * occurrence of each. Session contexts key their TTS processors by `translationKey` in a Map, so
 * duplicates would otherwise create an orphaned, never-stopped processor (resource/connection leak)
 * and list the same translation target twice. Call this before creating a session.
 */
export function dedupeOutputsByLanguage(outputs: Output[]): Output[] {
    const seen = new Set<string>();
    return outputs.filter(output => {
        const key = output.language.translationKey;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    });
}

export type Input = {
    id: string,
    device: MediaDeviceInfo,
    language: RecognizableAndTranslatableLanguage,
    gain: number,
    configComplete: boolean,
    autoDetect: boolean,
    translationKey?: string,
}

export type TranslationResult = {
    originalText: string,
    translatedText: string,
    status: string,
    language: Language
}

export type GlossaryTerm = {
    source: string                              // Source term in recognition language
    targets: { [languageCode: string]: string } // Per-language target translations
}

export type TranslationsBody = {
    inputs: { [key: string]: string },
    outputs: { [key: string]: string }
}

export type Translation = {
    id: number,
    originalText: string,
    translatedText: string,
    name?: string,
    timestamp: number
}

export class Recognition {
    constructor(duration: number, language: Language, offset: number, text: string) {
        this.id = Math.floor(Math.random() * 100000);
        this.duration = duration;
        this.language = language;
        this.offset = offset;
        this.text = text;
        this.timestamp = Date.now();
    }

    id: number;
    duration: number;
    language: Language;
    offset: number;
    text: string;
    timestamp: number;
}

export enum SessionStates {LOADING = 'loading', ON = 'on', OFF = 'off'}


export type SessionResponse =
    | (Omit<Response, 'json'> & {
    status: 201 | 200;
    json: () => SessionData | PromiseLike<SessionData>;
})
    | (Omit<Response, 'json'> & {
    status: 400;
    json: () => BadRequest | PromiseLike<BadRequest>;
});

export type SessionData = {
    sessionLive: boolean,
    sessionId: UUID,
    sessionSpeechToken: string,
    sessionDurationMillis: number,
    translations: Map<string, Translation[]>,
    errors: string
}

export type SpeechTokenData = {
    speechToken: string,
    expiresInSeconds?: number,
    errors: string
}

export type BadRequest = { code: 'bad_request'; message: string };

export type LoginInfo = {
    account: AccountInfo,
    token: string,
    roles: string[]
}

export type UserInfo = {
    name: string,
    email: string,
    tosAccepted: boolean,
}

// BILLING
export enum Currency {ARS = 'ARS', USD = 'USD'}

export enum PAYMENT_METHODS_OPERATIONS {
    'NONE' = 'none',
    'CREATE' = 'create',
    'UPDATE' = 'update',
}

export type PaymentMethodCreation = {
    secret: string,
    customer: string,
    stripeEnv: { name: string, publishableKey: string }
}

export type PaymentMethodGet = {
    paymentMethod: PaymentMethod,
    success: boolean
}

export type PaymentMethod = {
    paymentMethodId: string,
    stripeCustomer: string,
    brand: string,
    last4: string,
    isValid: boolean,
    expYear: string,
    expMonth: string
}

export type GenericResponse = {
    success: boolean,
    error: string
}

export type BroadcastSharecode = {
    userCode: string,
    sharecode: string,
    broadcastEnabled: boolean
}

export type BalanceHistory = {}

export type Balance = {
    balanceCredit: number,
    availableMinutes: number,
    ratePlanItems: RatePlanItem[],
    movements: Movement[],
    ratePlan?: RatePlan,
    // id: string,
    // date: string, //?????
    // //Entradas/Salidas de dinero
    // movements: Movement[],
    // //Salidas de minutos
    // consumptions: Consumption[],
    // currentCredit: number, //?????
    // totalConsumed: number //?????
    // //con cada session cerrada se genera un DEBIT_MOV con duracion, precio unitario y costo total
}

export type RatePlanFeatures = string[];

export type RatePlan = {
    id: string,
    name: string,
    description?: string,
    version?: number,
    features?: RatePlanFeatures,
    currency: Currency,
    items: RatePlanItem[],
    validUpToDate?: string | null,
    creationDate?: string,
    code?: string,
    defaultPlan?: boolean,
    template?: boolean,
    maxLiveUsersBySession?: number,
}

export type RatePlanItem = {
    code: string,
    name: string,
    description: string,
    price: number
}

export type Consumption = {
    id: number,
    userId: string,
    sessionId: string,
    duration: number,
    unit_price: number, //valor del dolar en el momento de generacion de consumo
    total_cost: number,
    movId: string //?????
}

export enum MovementType {DEBIT = 'DEBIT', CREDIT = 'CREDIT', DEBIT_NOTE = 'DEBIT_NOTE', CREDIT_NOTE = 'CREDIT_NOTE', }

export enum MovementStatus {APPROVED = 'APPROVED', REJECTED = 'REJECTED'}

export type Movement = {
    id: number,
    user: string,
    timestamp: string,
    zonedTimestamp: string,
    type: MovementType,
    status: MovementStatus,
    total: number,
    currency: Currency,
    duration?: number | null,
    sessionStartTime: string | null,
    sessionEndTime: string | null,
    billedConsumptions?: BilledConsumption[],
    currentBalance: number,
    totalRatePerMin: string,
    sessionStopReason?: string,
    sessionType?: 'standard' | 'twoWay',
    bidirectionalLanguages?: { languageName: string; languageKey: string; color: string }[]
}

export type MovementDto = {
    total: number | null,
    description: string | null,
    movementType: string | null,
    customerEmail: string | null
};

export type UserDto = { email: string, firstName: string, lastName: string, groups: UserGroup[], active: boolean };

export type User = {
    id: string,
    name: string,
    lastName: string,
    email: string,
    groupIds: string[],
    active: boolean,
    userCode: string,
    shareCode: string,
    zonedTimestamp?: string,
    timestamp: number,

    tosAccepted: boolean,
    tosSignature: string,
    tosTimestamp: number,
    zonedTosTimestamp?: string,
    ratePlanCode?: string | null,
}

export type UserGroup = {
    id: string,
    displayName: string,
    description: string,
}


export type AccountDto = { name: string, industry: string, country: string, active: boolean };
export type Account = {
    id: string,
    name: string,
    country: string,
    industry: string,

    userEmail: string,
    ownerId: string,
    status: string,

    active: boolean,
    timestamp: number,
    zonedTimestamp: string,
    subAccountIds: string[]
}

//For Service GetBalance
export type BalanceSummary = {
    records: BalanceRecord[]
}
export type BalanceRecord = {
    userId: string
    date: string,
    movType: MovementType,
    duration: number,
    amount: number,
    currency: Currency,
    balance: number //in mmillis!
}

export type BilledConsumption = {
    ratePlanItemCode: string;
    ratePlanItemDesc: string;
    ratePlantItemName: string;
    lang: string;
    amount: number;
    ratePerMin: string;
    total: string;
}

export type BidirectionalPanelConfig = {
    languageKey?: string;
    inputDeviceId?: string;
    outputDeviceId?: string;
    inputGain?: number;
    outputGain?: number;
    voiceName?: string;
    textOnly?: boolean;
    outputOnly?: boolean;
    inputOnly?: boolean;
    color?: string;
    activePanel?: boolean;
}

export type Config = {
    inputLanguage: string | null,
    inputDevice: string | null,
    inputDeviceConfig: MediaDeviceInfoWithState | null,
    inputGain: number | null,

    outputLanguages: { [key: string]: string },
    outputDevices: { [key: string]: string },
    outputDevicesConfig: { [key: string]: MediaDeviceInfoWithState },
    biPanelOutputDevicesConfig: { [key: string]: MediaDeviceInfoWithState },
    outputGains: { [key: string]: number },
    outputTextOnly: { [key: string]: boolean },
    outputVoices: { [key: string]: string },

    sessionDuration: number,
    modelType: string,

    useDictionary: boolean,
    disabledGlossaryIds?: string[],
    isTwoWayMode?: boolean,
    bidirectionalPanelsConfig?: { [panelId: string]: BidirectionalPanelConfig },
    activeInputPanelId?: string | null,
    floorFeedEnabled?: boolean,
    remoteControlPlaySound?: boolean,
    remoteControlSoundDeviceId?: string,
    remoteControlSoundDeviceConfig?: MediaDeviceInfoWithState | null,
    remoteControlSoundVolume?: number,
    hideAudioSettingsInTwoWaySession?: boolean,
}


// DUMMIES
export const dummyEsLanguage = {
    id: 'es',
    name: 'spanish',
    nativeName: 'español'
} as Language;

export const dummyEnLanguage = {
    id: 'en',
    name: 'english',
    nativeName: 'english'
} as Language;


export type BroadcastSharecodeResponse =
    | (Omit<Response, 'json'> & {
    status: 201 | 200;
    json: () => BroadcastSharecode | PromiseLike<BroadcastSharecode>;
})
    | (Omit<Response, 'json'> & {
    status: 400;
    json: () => BadRequest | PromiseLike<BadRequest>;
});

export type UserInfoResponse =
    | (Omit<Response, 'json'> & {
    status: 201 | 200;
    json: () => UserInfo | PromiseLike<UserInfo>;
})
    | (Omit<Response, 'json'> & {
    status: 400;
    json: () => BadRequest | PromiseLike<BadRequest>;
});
export type BalanceResponse =
    | (Omit<Response, 'json'> & {
    status: 201 | 200;
    json: () => Balance | PromiseLike<Balance>;
})
    | (Omit<Response, 'json'> & {
    status: 400;
    json: () => BadRequest | PromiseLike<BadRequest>;
});
export type PaymentMethodCreationResponse = | (Omit<Response, 'json'> & {
    status: 201 | 200;
    json: () => PaymentMethodCreation | PromiseLike<PaymentMethodCreation>;
})
    | (Omit<Response, 'json'> & {
    status: 400;
    json: () => BadRequest | PromiseLike<BadRequest>;
});
export type PaymentMethodGetResponse = | (Omit<Response, 'json'> & {
    status: 201 | 200;
    json: () => PaymentMethodGet | PromiseLike<PaymentMethodGet>;
})
    | (Omit<Response, 'json'> & {
    status: 400;
    json: () => BadRequest | PromiseLike<BadRequest>;
});

export type MakePaymentResponse = | (Omit<Response, 'json'> & {
    status: 201 | 200;
    json: () => GenericResponse | PromiseLike<GenericResponse>;
})
    | (Omit<Response, 'json'> & {
    status: 400;
    json: () => BadRequest | PromiseLike<BadRequest>;
});

export type RatePlanResponse = | (Omit<Response, 'json'> & {
    status: 201 | 200;
    json: () => RatePlan | PromiseLike<RatePlan>;
})
    | (Omit<Response, 'json'> & {
    status: 400;
    json: () => BadRequest | PromiseLike<BadRequest>;
});

export type UsersResponse = | (Omit<Response, 'json'> & {
    status: 201 | 200;
    json: () => { success: boolean, users: User[], groups: UserGroup[] } | PromiseLike<{
        success: boolean,
        users: User[],
        groups: UserGroup[]
    }>;
})
    | (Omit<Response, 'json'> & {
    status: 400;
    json: () => BadRequest | PromiseLike<BadRequest>;
});

export type AccountsResponse = | (Omit<Response, 'json'> & {
    status: 201 | 200;
    json: () => { success: boolean, accounts: Account[], industries: string[], countries: string[] } | PromiseLike<{
        success: boolean, accounts: Account[], industries: string[], countries: string[]
    }>;
})
    | (Omit<Response, 'json'> & {
    status: 400;
    json: () => BadRequest | PromiseLike<BadRequest>;
});

export type ReportResponse = | (Omit<Response, 'json'> & {
    status: 201 | 200;
    json: () => { success: boolean, allMovements: Movement[], users: User[] } | PromiseLike<{
        success: boolean,
        allMovements: Movement[],
        users: User[]
    }>;
})
    | (Omit<Response, 'json'> & {
    status: 400;
    json: () => BadRequest | PromiseLike<BadRequest>;
});


export type Broadcast = {
    error?: string,
    translations: { [key: string]: { [key: string]: string[] } }
}

export type BroadcastResponse = Omit<Response, 'json'> & {
    status: 200 | 201 | 400;
    json: () => Broadcast | PromiseLike<Broadcast>;
}
